import { GetterTree } from 'vuex';
import { BoardSectionModel, BoardSectionInfo } from '@descomplica/dex-models';
import { BoardSectionState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<BoardSectionState, RootState> = {
  boardSectionById: (state, boardSectionsGetters) => (boardSectionId: number) => {
    const boardSection = state.boardSections[boardSectionId.toString()];
    return boardSection ? new BoardSectionModel(boardSection, boardSectionsGetters) : undefined;
  },
  boardSectionsByBoardId: (state, boardSectionsGetters) => (boardId: number) => {
    return Object.values(state.boardSections)
      .map(
        (boardSection: BoardSectionInfo) =>
          new BoardSectionModel(boardSection, boardSectionsGetters),
      )
      .filter((boardSection) => boardSection.boardId === boardId);
  },
};

export default getters;
